import script from "./NewsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./NewsDetail.vue?vue&type=style&index=0&id=43200ff4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43200ff4"]])

export default __exports__